'use strict';

var noop = function noop() {};
var isFunction = function isFunction(fn) {
    return typeof fn === 'function';
};

var apis = {
    /**
     * 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口<br />
     * 对应native接口：onMenuShareTimeline
     * @method hysdk.onMenuShareTimeline
     * @category Share
     * @example ./onMenuShareTimeline.js[1-14]
     * @description
     *
     * 参数与 shareTimeline API一致
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    onMenuShareTimeline: true,
    /**
     * 获取“分享给朋友”按钮点击状态及自定义分享内容接口<br />
     * 对应native接口：onMenuShareAppMessage
     * @method hysdk.onMenuShareAppMessage
     * @category Share
     * @example ./onMenuShareAppMessage.js[1-14]
     * @description
     *
     * 参数与 shareTimeline API一致
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    onMenuShareAppMessage: true,
    /**
     * 获取“新浪微博”按钮点击状态及自定义分享内容接口<br />
     * 对应native接口：onMenuShareWeiboApp
     * @method hysdk.onMenuShareWeiboApp
     * @category Share
     * @example ./onMenuShareWeiboApp.js[1-14]
     * @description
     *
     * 参数与 shareTimeline API一致
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X  |
     * | ctrip   |   X  |
     *
     */
    onMenuShareWeiboApp: true,
    /**
     * 获取“腾讯微博”按钮点击状态及自定义分享内容接口<br />
     * 对应native接口：onMenuShareWeibo
     * @method hysdk.onMenuShareWeibo
     * @category Share
     * @example ./onMenuShareWeibo.js[1-14]
     * @description
     *
     * 参数与 shareTimeline API一致
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    onMenuShareWeibo: {
        wechat: true,
        hy: 'onMenuShareWeibo'
    },
    /**
     * 获取“分享给QQ”按钮点击状态及自定义分享内容接口<br />
     * 对应wechat接口：onMenuShareQQ
     * @method hysdk.onMenuShareQQ
     * @category Share
     * @example ./onMenuShareQQ.js[1-14]
     * @description
     *
     * 参数与 shareTimeline API一致
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   X   |
     * | Hy Browser | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    onMenuShareQQ: {
        wechat: true
    },
    /**
     * 获取“分享到QZone”按钮点击状态及自定义分享内容接口<br />
     * 对应wechat接口：onMenuShareQZone
     * @method hysdk.onMenuShareQZone
     * @category Share
     * @example ./onMenuShareQZone.js[1-14]
     * @description
     *
     * 参数与 shareTimeline API一致
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   X   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   X   |
     *
     */
    onMenuShareQZone: {
        wechat: true
    },
    /**
     * 获取“短信”按钮点击状态及自定义分享内容接口<br />
     * 对应native接口：onMenuShareSMS
     * @method hysdk.onMenuShareSMS
     * @category Share
     * @example ./onMenuShareSMS.js[1-14]
     * @description
     *
     * 参数与 shareTimeline API一致
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    onMenuShareSMS: {
        hy: true
    },
    /**
     * 获取“邮件”按钮点击状态及自定义分享内容接口<br />
     * 对应native接口：onMenuShareEmail
     * @method hysdk.onMenuShareEmail
     * @category Share
     * @example ./onMenuShareEmail.js[1-15]
     * @description
     *
     * 参数与 shareTimeline API一致
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    onMenuShareEmail: {
        hy: true
    },
    /**
     * 获取“去哪儿好友”按钮点击状态及自定义分享内容接口<br />
     * 对应native接口：onMenuShareQunarIM
     * @method hysdk.onMenuShareQunarIM
     * @category Share
     * @example ./onMenuShareQunarIM.js[1-15]
     * @description
     *
     * 参数与 shareTimeline API一致
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X   |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    onMenuShareQunarIM: {
        hy: true
    },
    /**
     * 设置通用分享内容接口。自定义通用分享内容，并获取分享状态<br />
     * 对应native接口：onMenuShare
     * @method hysdk.onMenuShare
     * @category Share
     * @example ./onMenuShare.js[1-14]
     * @description
     *
     * 参数与 shareTimeline API一致
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | √    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     * Hy Browser: 默认获取网页标题和链接，可以设置通用分享内容，此时只支持设置通用分享内容，不支持对微博、微信分别设置分享内容
     */
    onMenuShare: {
        hy: true
    }
};

var getCallback = function getCallback(options, debug) {
    options = options || {};
    var successCb = options.success,
        failCb = options.fail,
        completeCb = options.complete;
    delete options.success;
    delete options.fail;
    delete options.complete;
    return function (data) {
        debug && console.info('[HySDK] Hy Callback Data:', data);
        if (!data || typeof data.ret === 'undefined') {
            isFunction(successCb) && successCb(data);
        } else if (data.ret) {
            isFunction(successCb) && successCb(data.data);
        } else {
            isFunction(failCb) && failCb(data);
        }
        isFunction(completeCb) && completeCb(data);
    };
};

var wechatApis = [];

module.exports = {
    init: function init(sdk, debug) {
        var _loop = function _loop(key) {
            if (apis.hasOwnProperty(key)) {
                var conf = apis[key];
                sdk[key] = function (opt) {
                    return sdk.ready(function (env) {
                        if (sdk[env][key]) {
                            sdk[env][key](opt);
                        } else {
                            //TODO 考虑是否应该报 warn
                            debug && console.warn('[HySDK] ' + env + ' not support "' + key + '"!');
                        }
                    });
                };
                if (conf === true || conf.wechat) {
                    wechatApis.push(key);
                    sdk.wechat[key] = function (opt) {
                        return sdk.ready(function (env) {
                            return env === 'wechat' && sdk.bridge[key](opt);
                        });
                    };
                }
                if (conf === true || conf.hy) {
                    // let bridgeName = typeof conf.hy === 'string' ? conf.hy : key;
                    sdk.hy[key] = function (opt) {
                        return sdk.ready(function (env) {
                            if (env === 'hy') {
                                sdk.bridge.invoke(key, getCallback(opt), opt);
                                // 每次页面 show 时，重新设置一次
                                sdk.hy.on('show', function () {
                                    return sdk.bridge.invoke(key, noop, opt);
                                });
                            }
                        });
                    };
                }
            }
        };

        for (var key in apis) {
            _loop(key);
        }

        sdk.wechat.onMenuShare = function (opt) {
            wechatApis.forEach(function (key) {
                return sdk.wechat[key](opt);
            });
        };
    },
    wechatApis: wechatApis
};


//////////////////
// WEBPACK FOOTER
// ../src/share.js
// module id = 28
// module chunks = 0 2 4